import { render, staticRenderFns } from "./KioskCheckin.vue?vue&type=template&id=08612f0a&scoped=true&"
import script from "./KioskCheckin.vue?vue&type=script&lang=js&"
export * from "./KioskCheckin.vue?vue&type=script&lang=js&"
import style0 from "./KioskCheckin.vue?vue&type=style&index=0&id=08612f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08612f0a",
  null
  
)

component.options.__file = "KioskCheckin.vue"
export default component.exports